import R from 'ramda';
import addSubTemplate from './addSubPopup.html';
import addClassTemplate from '../olr-mainfe-class/addClassPopup.html';
import addClassTemplateExt from '../olr-mainfe-class/addClassPopupExt.html';
import moment from 'moment';

export default function DashboardController($location, $scope, $rootScope, $q, $state, $mdDialog, ClassRoomService, SubjectService, localStorageService, $log, TodoListService, AttendanceService, StudentService, AnnouncementService) {

	var self = this;

  var animateDashBoard = function(){
    setTimeout(function(){
      $('.box').css("opacity", '1');
      $('.box').css("transform", 'translateX(0px)');
      $('.box').css("-webkit-transform", 'translateX(0px)');
    }, 200);
  }

  var init = function(){
    $q.all([subjectPromise, classRoomPromise, toDoPromise, annPromise]).then(function(){
      $rootScope.showSpinner = false;
      animateDashBoard();
    });

  };

  self.showAddSubject = true;
  self.showAddClass = true;
  $rootScope.showSpinner = true;
  var subjectPromise;
  var annPromise;

  /************************************* Subject Pane *******************************/
  
  this.getAllSubjects = function(){
    subjectPromise = SubjectService.getAllSubjects().then(function(resp){
      if(resp.data.length > 0){
        self.allSubjects = resp.data;
        localStorageService.set('subjects', self.allSubjects);
        self.showAddSubject = false;
      }
      else{
        self.allSubjects = [];
        self.showAddSubject = true;
      }
    });
  };

  self.editSubject = function(subject){
    self.addSubject(subject);
  };

  self.deleteSubject = function(subject){
    SubjectService.deleteSubject(subject).then(function(resp) {
      if(resp.data.isDeleted){
        let deleteIndex = R.findIndex(R.propEq('subjectId', subject.subjectId))(self.allSubjects);
        if (deleteIndex > -1) {
          self.allSubjects.splice(deleteIndex, 1);
        }
        localStorageService.set('subjects', self.allSubjects);
        if(self.allSubjects.length === 0){
          self.showAddSubject = true;
        }
      }
    });
  };

  self.getAllSubjects();   // Getting Subjects from Servcice

  $scope.$emit('classRoomRefresh', {});

  self.addSubject = function(subject){
    $mdDialog.show({
      template: addSubTemplate,
      controller: AddSubjectController,
      locals : {subject : subject}
    }).finally(function(){
      //Do Nothing Here
    });
  };

  var AddSubjectController = function($scope, $mdDialog, subject){
    $scope.subjectObj = subject || {subjectName: '', subjectDesc: ''};

    $scope.closeDialog = function() {
      $mdDialog.hide();
    };

    $scope.saveDialog = function() {
      if($scope.addSubjectForm.$invalid){
        angular.forEach($scope.addSubjectForm, function(val, key) {
          if (!key.match(/\$/)) {
            val.$dirty = true;
            val.$touched = true;
          }
        });
        return;
      }
      
      SubjectService.saveSubject($scope.subjectObj).then(function(resp) {
        $scope.subjectObj.subjectId = resp.data.subjectId;

        if(resp.data.subjectId || resp.data.subject == 'updated'){
          self.allSubjects.push($scope.subjectObj);
          localStorageService.set('subjects', self.allSubjects);
        }

        self.allSubjects = localStorageService.get('subjects') || [];
        if(self.allSubjects.length > 0){
          self.showAddSubject = false;
        }
        //$state.go('olr.mainfe.contact');
      });
      //self.studentArray.push({studentName: $scope.student.studentName, emailId: $scope.student.emailId});
      $mdDialog.hide();
    };
  };

  /*********************************************************************************************************************/

  /************************************* Class Pane ********************************************************************/
  var classRoomPromise;

  this.getAllClassRooms = function(){
    classRoomPromise = ClassRoomService.getAllClassRooms().then(function(resp){
      if(resp.data.length > 0){
        self.allClassRooms = resp.data;
        localStorageService.set('classrooms', self.allClassRooms);
        self.showAddClass = false;
      }
      else{
        self.allClassRooms = [];
        self.showAddClass = true;
      }
    });
  };

  self.getAllClassRooms();

  $scope.querySearch   = querySearch;
  $scope.selectedClassChange = selectedClassChange;
  $scope.searchTextChange   = searchTextChange;

  $scope.newClassRoom = function(classRoomName) {
    $mdDialog.hide();
    self.addSubject({'classRoomName':classRoomName, 'subjectId': ''});
  };

  function querySearch (query) {
    var results = query ? self.allClassRooms.filter( createFilterFor(query) ) : self.allClassRooms,
      deferred;
    if (self.simulateQuery) {
      deferred = $q.defer();
      $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
      return deferred.promise;
    } 
    else {
      return results;
    }
  }

  function searchTextChange(text) {
    $scope.displayAutoCompleteError = false;
    $log.info('Text changed to ' + text);
  }

  function selectedClassChange(item) {
    $log.info('Item changed to ' + JSON.stringify(item));
  }

  /**
   * Create filter function for a query string
   */
  function createFilterFor(query) {
    var lowercaseQuery = angular.lowercase(query);

    return function filterFn(classObj) {
      return (classObj.classRoomName.toLowerCase().indexOf(lowercaseQuery) === 0);
    };
  }

  self.editIndvClass = function(classObj){
    $state.go('olr.mainfe.indvclass', {classRoomName: classObj.classRoomName, subName:classObj.subjectName, cId: classObj.classRoomId });
  };

  self.deleteIndvClass = function(classObj){
    ClassRoomService.deleteClassRoom(classObj).then(function(resp) {
      let deleteIndex = R.findIndex(R.propEq('classRoomId', classObj.classRoomId))(self.allClassRooms);
      if (deleteIndex > -1) {
        self.allClassRooms.splice(deleteIndex, 1);
      }
      localStorageService.set('classrooms', self.allClassRooms);
      if(self.allClassRooms.length === 0){
        self.showAddClass = true;
      }
    });
  };

  self.addClassRoom = function(classRoom){
    $mdDialog.show({
      template: addClassTemplate,
      controller: AddClassController,
      locals : {classRoom : classRoom}
    }).finally(function(){
      //Do Nothing Here
    });
  };

  self.addClassRoomExt = function(classRoom, studentListInClass, originalReq){
    $mdDialog.show({
      template: addClassTemplateExt,
      controller: AddClassExtController,
      locals : {classRoom : classRoom, studentListInClass: studentListInClass, originalReq: originalReq}
    }).finally(function(){
      console.log('extension pop up closed');
      //Do Nothing Here
    });
  };

  var AddClassExtController = function($scope, $mdDialog, $log, classRoom, studentListInClass, originalReq){
    $scope.querySearch   = querySearch;
    $scope.selectedStudentChange = selectedStudentChange;
    $scope.searchTextChange   = searchTextChange;
    $scope.simulateQuery = true;

    function querySearch (query) {
      var results = query ? $scope.studentList.filter( createFilterFor(query) ) : $scope.studentList,
        deferred;
      if ($scope.simulateQuery) {
        deferred = $q.defer();
        if(query){
          StudentService.getStudentsByChar(query).then(function(resp){
            results = resp.data;
            deferred.resolve( results );
          });
        }else{
          results = [];
          deferred.resolve(results);
          // StudentService.getAllStudents().then(function(resp){
          //   results = resp.data;
          //   deferred.resolve( results );
          // });
        }
        //$timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
        return deferred.promise;
      } 
      else {
        return results;
      }
    }

    function searchTextChange(text) {
      console.log('Text changed to ' + text);
    }

    function selectedStudentChange(item) {
      if(item){
        $scope.student.emailId = item.studentId;
        $scope.studentSelected = item;
        $scope.showStuExistErr = false;
        $scope.showSelectStudErr = false;
      }
      else{
        $scope.student.emailId = '';
        $scope.studentSelected = '';
      }
      console.log('Item changed to ' + JSON.stringify(item));
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(stuObj) {
        return (stuObj.studentName.toLowerCase().indexOf(lowercaseQuery) === 0);
      };
    }

    $scope.showStuExistErr = false;
    $scope.showSelectStudErr = false;

    $scope.student = {studentName: '', emailId: ''};
    $scope.addedStudentsList = studentListInClass;

    $scope.addStudent = function(){
      if($scope.studentSelected){
        if(R.findIndex(R.propEq('studentId', $scope.studentSelected.studentId))($scope.addedStudentsList) > -1){
          $scope.showStuExistErr = true;
        }else{
          $scope.addedStudentsList.push($scope.studentSelected);
        }
      }
      else{
        $scope.showSelectStudErr = true;
      }
      $scope.student.emailId = '';
      $scope.searchText = '';
      $scope.selectedStudent = undefined;
      setTimeout(function(){
        angular.element('#auto_complete').find('input').focus();
      },0);
    };

    $scope.closeDialog = function() {
      $mdDialog.hide();
    };

    $scope.saveDialog = function() {
      if($scope.addedStudentsList.length < 1){
        $scope.showSelectStudErr = true;
        return;
      }
      var classRoomList = localStorageService.get('classrooms');
      var classObj = {'updateStatus': 'addStudents'};

      classObj.subjectId = classRoom.subjectId;
      classObj.subjectName = classRoom.subjectName;
      classObj.classRoomId = classRoom.classRoomId;
      classObj.studentArray = $scope.addedStudentsList;
      let tempReq = {
        'classRoomName' : classRoom.classRoomName, 
        'subjectName': originalReq.subjectName, 
        'subjectId': originalReq.subjectId,
        'createClassAnyway': 'secondCheck'
      };
      ClassRoomService.saveClassRoom(tempReq).then(function(resp) {
        tempReq.classRoomId = resp.data.classRoomId;
        classObj.classRoomId = resp.data.classRoomId;
        //console.log(resp.data);
        ClassRoomService.updateClassRoom(classObj).then(function(resp){
          //console.log(resp.data);
          //self.getClassDetails();
        });
        
        if(resp.data.classRoomId && !resp.data.classRoomExist){
          self.allClassRooms.push(tempReq);
          localStorageService.set('classrooms', self.allClassRooms);
        }


        if(resp.data.classRoomExist){
          $scope.showClassExistError = true;
        }
        else{
          self.allClassRooms = localStorageService.get('classrooms') || [];
          if(self.allClassRooms.length > 0){
            self.showAddClass = false;
          }
          $mdDialog.hide();
        }
        //$state.go('olr.mainfe.contact');
      });
      // self.newStudentArray.push({studentName: $scope.student.studentName, emailId: $scope.student.emailId});
      $mdDialog.hide();
    };
  };

  var AddClassController = function($scope, $mdDialog, $log, classRoom){
    $scope.classObj = classRoom || {classRoomName: '', subject: ''};

    // if(classRoom){
    //   $scope.selectedSubject = {'subjectName':classRoom.subjectName, 'subjectId': classRoom.subjectId}
    // }
    $scope.querySearch   = querySearch;
    $scope.selectedSubjectChange = selectedSubjectChange;
    $scope.searchTextChange   = searchTextChange;

    $scope.newSubject = function(subjectName) {
      $mdDialog.hide();
      self.addSubject({'subjectName':subjectName, 'subjectDesc': ''});
    };

    function querySearch (query) {
      var results = query ? self.allSubjects.filter( createFilterFor(query) ) : self.allSubjects,
        deferred;
      if (self.simulateQuery) {
        deferred = $q.defer();
        $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
        return deferred.promise;
      } 
      else {
        return results;
      }
    }

    function searchTextChange(text) {
      $scope.displayAutoCompleteError = false;
      $log.info('Text changed to ' + text);
    }

    function selectedSubjectChange(item) {
      $log.info('Item changed to ' + JSON.stringify(item));
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(classObj) {
        return (classObj.subjectName.toLowerCase().indexOf(lowercaseQuery) === 0);
      };
    }

    $scope.closeDialog = function() {
      $mdDialog.hide();
    };

    $scope.saveDialog = function(param) {

      $scope.displayAutoCompleteError = $scope.selectedSubject ? false : true;
      if($scope.addClassForm.$invalid || $scope.displayAutoCompleteError){
        angular.forEach($scope.addClassForm, function(val, key) {
          if (!key.match(/\$/)) {
            val.$dirty = true;
            val.$touched = true;
          }
        });
        return;
      }

      let tempReq = {
        'classRoomName' : $scope.classObj.classRoomName, 
        'subjectName': $scope.selectedSubject.subjectName, 
        'subjectId': $scope.selectedSubject.subjectId,
        'createClassAnyway': 'firstCheck'
      };
      ClassRoomService.saveClassRoom(tempReq).then(function(resp) {
        tempReq.classRoomId = resp.data.classRoomId;

        if(resp.data.classRoomExistOnDiffSub){
          console.log(JSON.stringify(resp.data));
          ClassRoomService.getClassRoomStudents(resp.data.existingClassRoomId, resp.data.diffSubjectDetails.subjectId).then(function(sturesp){
            if(sturesp.data.allStudents.length > 0){
              self.addClassRoomExt(resp.data.currentClassObj, sturesp.data.allStudents, tempReq);
            }
            else{
              tempReq.createClassAnyway = "secondCheck";
              ClassRoomService.saveClassRoom(tempReq).then(function(resp1) {
                tempReq.classRoomId = resp1.data.classRoomId;
                //console.log(resp.data);
                
                if(resp1.data.classRoomId && !resp1.data.classRoomExist){
                  self.allClassRooms.push(tempReq);
                  localStorageService.set('classrooms', self.allClassRooms);
                }


                if(resp1.data.classRoomExist){
                  $scope.showClassExistError = true;
                }
                else{
                  self.allClassRooms = localStorageService.get('classrooms') || [];
                  if(self.allClassRooms.length > 0){
                    self.showAddClass = false;
                  }
                  //$mdDialog.hide();
                }
                //$state.go('olr.mainfe.contact');
              });
            }
          })
        }
        
        if(resp.data.classRoomId && !resp.data.classRoomExist){
          self.allClassRooms.push(tempReq);
          localStorageService.set('classrooms', self.allClassRooms);
        }


        if(resp.data.classRoomExist){
          $scope.showClassExistError = true;
        }
        else{
          self.allClassRooms = localStorageService.get('classrooms') || [];
          if(self.allClassRooms.length > 0){
            self.showAddClass = false;
          }
          $mdDialog.hide();
        }
        //$state.go('olr.mainfe.contact');
      });
      //self.studentArray.push({studentName: $scope.student.studentName, emailId: $scope.student.emailId});
    };
  };

  /*****************************************************************************************************************/

  /********************************************** Announcements pane ************************************************/

  self.goToAnnouncement = function(){
    $state.go('olr.mainfe.announcement');
  };

  this.getAllAnnouncements = function(){
    annPromise = AnnouncementService.getAllAnns().then(function(resp){
      if(resp.data.length > 0){
        console.log(resp.data);
        self.allAnns = resp.data;
        localStorageService.set('subjects', self.allSubjects);
        self.showAddAnn = false;
      }
      else{
        self.allAnns = [];
        self.showAddAnn = true;
      }
    });
  };

  self.getAllAnnouncements();

  /*****************************************************************************************************************/

  /********************************************** ToDo List **********************************************************/

  /*
  * Call Service to get todolist
  */
  self.todoList = [];

  var toDoPromise;

  var changeToDoStatus = function(item, status){
    for(var i=0; i<self.todoList.length; i++){
      if(self.todoList[i].todoDesc == item.todoDesc){
        var reqObj = self.todoList[i]
        reqObj.status = status;
        console.log(reqObj);
        TodoListService.saveTodo(reqObj).then(function(resp){
          console.log(resp.data);
          for(var j=0; j<self.todoList.length; j++){
            if(self.todoList[j].todoDesc == resp.data.todoDesc){
              self.todoList[j].status = resp.data.status;
            }
          }
        });
      }
    }
  };

  var updatePendingTasks = function(){
    self.todoList = R.uniq(self.todoList);
    $scope.selected = R.uniq($scope.selected);
    $scope.pendingTasks = self.todoList.length - $scope.selected.length;
  };

  $scope.selected = [];

  var getAllTodos = function(){
    toDoPromise = TodoListService.getAllTodo().then(function(resp){
      if(resp.data.length > 0){
        self.todoList = resp.data;
        localStorageService.set('allTodos', self.todoList);
        updateSelectedList();
        updatePendingTasks();
      }
      else{
        self.todoList = [];
      }
    });
  }

  getAllTodos();

  var updateSelectedList = function(){
    if(self.todoList.length > 0){
      for(var i=0; i<self.todoList.length; i++){
        if(self.todoList[i].status == 'completed'){
          $scope.selected.push(self.todoList[i]);
        }
      }
      $scope.selected = R.uniq($scope.selected);
    }
  };

  $scope.toggle = function (item, list) {
    var idx = list.indexOf(item);
    if (idx > -1) {
      changeToDoStatus(item, 'pending');
      list.splice(idx, 1);
      updatePendingTasks();
    }
    else {
      changeToDoStatus(item, 'completed');
      list.push(item);
      updatePendingTasks();
    }
    $scope.selected = R.uniq($scope.selected);
  };

  $scope.exists = function (item, list) {
    return list.indexOf(item) > -1;
  };

  $scope.toggleAll = function (){
    if ($scope.selected.length === self.todoList.length) {
      $scope.selected = [];
    } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
      $scope.selected = self.todoList.slice(0);
    }
  };

  $scope.isChecked = function() {
    return $scope.selected.length === self.todoList.length;
  };

  self.addToDo = function(){
    if($scope.todo){
      var reqObj = {todoDesc: $scope.todo, status: 'pending'};
      TodoListService.saveTodo(reqObj).then(function(resp){
        if(resp.data.todoId){
          self.todoList.push(resp.data);
          localStorageService.set('allTodos', self.todoList);
          updatePendingTasks();

        }
        //self.showAddClass = false; // show add to do image
        $scope.todo = "";
      });
    }
  };

  self.deleteTodo = function(todoObj){
    TodoListService.deleteTodo(todoObj).then(function(resp){
      if(resp.data.isDeleted){
        let deleteIndex = R.findIndex(R.propEq('todoId', todoObj.todoId))(self.todoList);
        if (deleteIndex > -1) {
          self.todoList.splice(deleteIndex, 1);
        }
        let deleteIndexOnSelectList = R.findIndex(R.propEq('todoId', todoObj.todoId))($scope.selected);
        if (deleteIndexOnSelectList > -1) {
          $scope.selected.splice(deleteIndexOnSelectList, 1);
        }
        localStorageService.set('allTodos', self.todoList);
        updatePendingTasks();
      }
      //self.showAddClass = false; // show add to do image
    });  
  };

  updatePendingTasks();

  /**********************************************************************************************************************/

  /****************************************** Attendance ****************************************************************/

  $scope.day = moment().format('YYYY-MM-DD');
  $scope.calFilledDates = [];

  this.getAllFilledDates = function(item){
    if(self.selectedClassAtt){
      AttendanceService.getAllDates(item.classRoomId, item.subjectId).then(function(resp){
        console.log(resp.data);
        $scope.calFilledDates = resp.data[0].filledDates;
        $scope.showDots = true;
      });
    }   
  };

  $scope.querySearch1   = querySearch1;
  $scope.selectedClassChange1 = selectedClassChange1;
  $scope.searchTextChange1   = searchTextChange1;

  $scope.newClassRoom1 = function(classRoomName) {
    $mdDialog.hide();
    self.addSubject({'classRoomName':classRoomName, 'subjectId': ''});
  };

  function querySearch1(query) {
    var results = query ? self.allClassRooms.filter( createFilterFor1(query) ) : self.allClassRooms,
      deferred;
    if (self.simulateQuery) {
      deferred = $q.defer();
      $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
      return deferred.promise;
    } 
    else {
      return results;
    }
  }

  function searchTextChange1(text) {
    $scope.displayAutoCompleteError = false;
    $log.info('Text changed to ' + text);
  }

  function selectedClassChange1(item) {
    if(item){
      self.selectedClassAtt = item;
      self.getAllFilledDates(item)
    }
    else{
      $scope.showDots = false;
      self.selectedClassAtt = "";
    }
    $log.info('Item changed to ' + JSON.stringify(item));
  }

  /**
   * Create filter function for a query string
   */
  function createFilterFor1(query) {
    var lowercaseQuery = angular.lowercase(query);

    return function filterFn(classObj) {
      return (classObj.classRoomName.toLowerCase().indexOf(lowercaseQuery) === 0);
    };
  }

  this.goToAttendance = function(){
    var formattedDate = moment($scope.day).format('YYYY-MM-DD');
    if(self.selectedClassAtt){
      $state.go('olr.mainfe.attendance', {classRoomName: self.selectedClassAtt.classRoomName, date:formattedDate, cId: self.selectedClassAtt.classRoomId });
    }
  };


  /***********************************************************************************************************************/

  init();
}



/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-dashboard/DashboardController.js
 **/